import React, { useState } from "react";
import Avatar from "../Assets/Avatar.png";

const TasksTable = ({ setEditTask }) => {
  const [dialogOpen, setDialogOpen] = useState(null);
  return (
    <div className="w-full shadow-md sm:rounded-lg my-3">
      <table className="w-full text-sm text-left text-gray-500">
        <thead className="text-xs text-gray-700 uppercase bg-white border-b">
          <tr>
            <th scope="col" className="p-4">
              <div className="flex items-center">
                <input
                  id="checkbox-all-search"
                  type="checkbox"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-2"
                />
                <label htmlFor="checkbox-all-search" className="sr-only">
                  checkbox
                </label>
              </div>
            </th>
            <th scope="col" className="px-4 py-3">
              Assignee
            </th>
            <th scope="col" className="px-6 py-3">
              Task
            </th>
            <th scope="col" className="px-6 py-3">
              Status
            </th>
            <th scope="col" className="px-6 py-3">
              Project Name
            </th>
            <th scope="col" className="px-6 py-3 flex items-center">
              Due Date
              <svg
                className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-uqopch ml-0.5"
                focusable="false"
                aria-hidden="true"
                viewBox="0 0 24 24"
                data-testid="UnfoldMoreIcon"
                width={18}
                height={18}
              >
                <path d="M12 5.83 15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z" />
              </svg>
            </th>
            <th scope="col" className="px-6 py-3"></th>
          </tr>
        </thead>
        <tbody>
          {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((tableRow, index) => {
            return (
              <tr
                className="bg-white border-b cursor-pointer hover:bg-gray-50"
                onClick={() => setEditTask(true)}
              >
                <td className="w-4 p-4">
                  <div className="flex items-center">
                    <input
                      id="checkbox-table-search-1"
                      type="checkbox"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-2"
                    />
                    <label
                      htmlFor="checkbox-table-search-1"
                      className="sr-only"
                    >
                      checkbox
                    </label>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <img
                    class="w-10 h-10 rounded-full"
                    src={Avatar}
                    alt="assignee"
                  />
                </td>
                <td className="px-6 py-4">
                  Upload feed and Reels in Instagrame
                </td>
                <td className="px-6 py-4">
                  {tableRow % 2 == 0 ? (
                    <span className="bg-green-100 text-green-800 text-xs font-medium mr-2 px-2.5 py-1 rounded-md">
                      Completed
                    </span>
                  ) : (
                    <span className="bg-blue-100 text-blue-800 text-xs font-medium mr-2 px-2.5 py-1 rounded-md">
                      In progress
                    </span>
                  )}
                </td>
                <td className="px-6 py-4">Project Title</td>
                <td className="px-6 py-4">23 Nov 2022</td>
                <td className="px-6 py-4">
                  <div className="relative">
                    <button
                      className="py-2 px-2 rounded-lg hover:bg-gray-100"
                      onClick={(e) => {
                        e.stopPropagation();
                        setDialogOpen(index === dialogOpen ? null : index);
                      }}
                    >
                      <svg
                        width={18}
                        height={19}
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.40078 9.7939C5.40078 10.2713 5.21114 10.7291 4.87357 11.0667C4.53601 11.4043 4.07817 11.5939 3.60078 11.5939C3.12339 11.5939 2.66555 11.4043 2.32799 11.0667C1.99042 10.7291 1.80078 10.2713 1.80078 9.7939C1.80078 9.31651 1.99042 8.85867 2.32799 8.5211C2.66555 8.18354 3.12339 7.9939 3.60078 7.9939C4.07817 7.9939 4.53601 8.18354 4.87357 8.5211C5.21114 8.85867 5.40078 9.31651 5.40078 9.7939ZM10.8008 9.7939C10.8008 10.2713 10.6111 10.7291 10.2736 11.0667C9.93601 11.4043 9.47817 11.5939 9.00078 11.5939C8.52339 11.5939 8.06556 11.4043 7.72799 11.0667C7.39042 10.7291 7.20078 10.2713 7.20078 9.7939C7.20078 9.31651 7.39042 8.85867 7.72799 8.5211C8.06556 8.18354 8.52339 7.9939 9.00078 7.9939C9.47817 7.9939 9.93601 8.18354 10.2736 8.5211C10.6111 8.85867 10.8008 9.31651 10.8008 9.7939ZM14.4008 11.5939C14.8782 11.5939 15.336 11.4043 15.6736 11.0667C16.0111 10.7291 16.2008 10.2713 16.2008 9.7939C16.2008 9.31651 16.0111 8.85867 15.6736 8.5211C15.336 8.18354 14.8782 7.9939 14.4008 7.9939C13.9234 7.9939 13.4656 8.18354 13.128 8.5211C12.7904 8.85867 12.6008 9.31651 12.6008 9.7939C12.6008 10.2713 12.7904 10.7291 13.128 11.0667C13.4656 11.4043 13.9234 11.5939 14.4008 11.5939Z"
                          fill="#6B7280"
                        />
                      </svg>
                    </button>
                    {index == dialogOpen && (
                      <div className="w-[16rem] flex flex-col border rounded shadow divide-y-2 bg-white z-50 absolute right-8 ">
                        <div className="flex flex-col items-start gap-y-1 px-3 py-3">
                          <span className="text-gray-500 text-sm">Status</span>
                          <select
                            value="2"
                            className="w-full py-2 border-2 rounded-lg bg-gray-100"
                          >
                            <option value="2">Completed</option>
                            <option value="23">In Progress</option>
                          </select>
                        </div>
                        <span className="text-sm text-green-500 px-3 py-3">
                          Mark as complete
                        </span>
                        <span className="text-sm text-red-500 px-3 py-3">
                          Delete
                        </span>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="bg-white rounded-b-lg w-full">
        <nav
          className="flex flex-col items-start justify-between p-4 space-y-3 md:flex-row md:items-center md:space-y-0"
          aria-label="Table navigation"
        >
          <span className="text-sm font-normal text-gray-500">
            Showing <span className="font-semibold text-gray-900">1-10</span> of{" "}
            <span className="font-semibold text-gray-900">1000</span>
          </span>
          <ul className="inline-flex items-stretch -space-x-px">
            <li>
              <a
                href="#"
                className="flex items-center justify-center h-full py-1.5 px-3 ml-0 text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700"
              >
                <span className="sr-only">Previous</span>
                <svg
                  className="w-5 h-5"
                  aria-hidden="true"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </a>
            </li>
            <li>
              <a
                href="#"
                className="flex items-center justify-center px-3 py-2 text-sm leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700"
              >
                1
              </a>
            </li>
            <li>
              <a
                href="#"
                className="flex items-center justify-center px-3 py-2 text-sm leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700"
              >
                2
              </a>
            </li>
            <li>
              <a
                href="#"
                aria-current="page"
                className="z-10 flex items-center justify-center px-3 py-2 text-sm leading-tight border text-primary-600 bg-primary-50 border-primary-300 hover:bg-primary-100 hover:text-primary-700"
              >
                3
              </a>
            </li>
            <li>
              <a
                href="#"
                className="flex items-center justify-center px-3 py-2 text-sm leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700"
              >
                ...
              </a>
            </li>
            <li>
              <a
                href="#"
                className="flex items-center justify-center px-3 py-2 text-sm leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700"
              >
                100
              </a>
            </li>
            <li>
              <a
                href="#"
                className="flex items-center justify-center h-full py-1.5 px-3 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700"
              >
                <span className="sr-only">Next</span>
                <svg
                  className="w-5 h-5"
                  aria-hidden="true"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default TasksTable;
